// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ClientHome from './client/pages/ClientHome';
import ClientProfile from './client/pages/ClientProfile';
import ClientPurchased from './client/pages/ClientPurchased';
import ClientTreatments from './client/pages/ClientTreatments';
import ClientHistory from './client/pages/ClientHistory';
import ClientSettings from './client/pages/ClientSettings';
import AdminDashboard from './admin/pages/AdminDashboard';
import LiveSupport from './admin/pages/LiveSupport';
import UserManagement from './admin/pages/UserManagement';
import ServiceManagement from './admin/pages/ServiceManagement';
import TicketManagement from './admin/pages/TicketManagement';
import Backup from './admin/pages/Backup';
import PromoManagement from './admin/pages/Promo';
import ManagerDashboard from './manager/pages/ManagerDashboard';
import ManagerCalendar from './manager/pages/ManagerCalendar';
import ManagerBookingRequest from './manager/pages/ManagerBookingRequest';
import ManagerServices from './manager/pages/ManagerServices';
import ManagerTherapist from './manager/pages/ManagerTherapist';
import ManagerSettings from './manager/pages/ManagerSettings';
import ManagerPromos from './manager/pages/ManagerPromos';
import ManagerNotifications from './manager/pages/ManagerNotifications';
import favicon from './assets/favicon.png'; // 1. Import the image

function App() {
  // 2. Use useEffect to update the favicon when the component mounts
  useEffect(() => {
    const link = document.querySelector("link[rel~='icon']");
    if (link) {
      link.href = favicon;
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* Client Home - standalone (has its own sidebar) */}
        <Route path="/" element={<ClientHome />} />
        
        {/* Client routes with individual sidebar */}
        <Route path="/profile" element={<ClientProfile />} />
        <Route path="/purchased" element={<ClientPurchased />} />
        <Route path="/treatments" element={<ClientTreatments />} />
        <Route path="/history" element={<ClientHistory />} />
        <Route path="/settings" element={<ClientSettings />} />
        
        {/* Admin routes */}
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/live-support" element={<LiveSupport />} />
        <Route path="/admin/users" element={<UserManagement />} />
        <Route path="/admin/services" element={<ServiceManagement />} />
        <Route path="/admin/promo" element={<PromoManagement />} />
        <Route path="/admin/tickets" element={<TicketManagement />} />
        <Route path="/admin/backup" element={<Backup />} />
        
        {/* Manager routes */}
        <Route path="/manager/dashboard" element={<ManagerDashboard />} />
        <Route path="/manager/calendar" element={<ManagerCalendar />} />
        <Route path="/manager/booking-request" element={<ManagerBookingRequest />} />
        <Route path="/manager/services" element={<ManagerServices />} />
        <Route path="/manager/therapist" element={<ManagerTherapist />} />
        <Route path="/manager/promos" element={<ManagerPromos />} />
        <Route path="/manager/notifications" element={<ManagerNotifications />} />
        <Route path="/manager/settings" element={<ManagerSettings />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
